import { AnyAction } from "redux";
import { Dispatch } from "react";
import { ProductRaw, Result } from "../../../../interfaces";
import { Create } from "../../../../controllers/products";
import { Adapter } from "../../../../shared/adapter";
import { ProductAdapter } from "../../../../adapter/products-adapter";

export const FETCH_CREATE_PRODUCTS_REQUEST = 'FETCH_CREATE_PRODUCTS_REQUEST';
export const FETCH_CREATE_PRODUCTS_SUCCESS = 'FETCH_CREATE_PRODUCTS_SUCCESS';
export const FETCH_CREATE_PRODUCTS_FAILURE = 'FETCH_CREATE_PRODUCTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateProductsRequest = () => {
    return {
        type: FETCH_CREATE_PRODUCTS_REQUEST,
    };
};

const fetchCreateProductsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_PRODUCTS_SUCCESS,
        payload: data
    };
};

const fetchCreateProductsFailure = (error: any) => {
    return {
        type: FETCH_CREATE_PRODUCTS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (product:ProductRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateProductsRequest());
        try {
            const response = await Create(product);
            dispatch(fetchCreateProductsSuccess(
                Adapter.from(response.data).to((value) => new ProductAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateProductsFailure(error.message));
        }
    };
};
